import {AlertTriangle} from 'lucide-react'

interface ValidationAlertProps {
  message: string | null
}

function ValidationAlert({ message }: ValidationAlertProps) {
  if (!message)
    return null

  return (
    <div
      role="alert"
      className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 rounded-md px-4 py-3 text-sm font-medium"
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0 mt-0.5" aria-hidden="true" />
      <span>{message}</span>
    </div>
  )
}

export default ValidationAlert
